import { render, staticRenderFns } from "./VideoLinkCardParts.vue?vue&type=template&id=217baea3&scoped=true"
import script from "./VideoLinkCardParts.vue?vue&type=script&lang=ts"
export * from "./VideoLinkCardParts.vue?vue&type=script&lang=ts"
import style0 from "./VideoLinkCardParts.vue?vue&type=style&index=0&id=217baea3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217baea3",
  null
  
)

export default component.exports